import { module as Module } from 'modujs';
import { $html } from '../utils/dom';
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupModularPlugin from '../utils/swup/SwupModularPlugin';
import SwupLSPlugin from '../utils/swup/SwupLSPlugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import { CSS_CLASS, CUSTOM_EVENT } from '../config';

export default class extends Module {
    constructor(m) {
        super(m);

        this.onVisitStart = this.onVisitStart.bind(this);
        this.onVisitEnd = this.onVisitEnd.bind(this);
        this.beforeContentReplace = this.beforeContentReplace.bind(this);
        this.onContentReplace = this.onContentReplace.bind(this);
        this.onAnimationInStartBind = this.onAnimationInStart.bind(this);
        this.onAnimationOutStartBind = this.onAnimationOutStart.bind(this);
        this.onLinkAnchorBind = this.onLinkAnchor.bind(this);
        this.load = null;
    }

    init() {
        this.load = new Swup({
            containers: ['[data-load-container]'],
            animateHistoryBrowsing: true,
            linkToSelf: 'navigate',
            // cache: false,
            plugins: [
                new SwupLSPlugin({ modularInstance: this }),
                new SwupModularPlugin({ modularInstance: this }),
                new SwupPreloadPlugin({}),
                new SwupScrollPlugin({
                    animateScroll: window.matchMedia('(prefers-reduced-motion: reduce)').matches
                        ? false
                        : {
                              betweenPages: true,
                              samePageWithHash: true,
                              samePage: true
                          }
                })
            ]
        });

        this.load.hooks.on('visit:start', this.onVisitStart);
        this.load.hooks.on('visit:end', this.onVisitEnd);
        this.load.hooks.before('content:replace', this.beforeContentReplace);
        this.load.hooks.on('content:replace', this.onContentReplace);
        this.load.hooks.on('animation:in:start', this.onAnimationInStartBind);
        this.load.hooks.on('animation:out:start', this.onAnimationOutStartBind);
        this.load.hooks.on('link:anchor', this.onLinkAnchorBind);

        const hash = window.location.hash;
        if (hash && document.querySelector(hash)) {
            requestAnimationFrame(() => {                
                this.call('scrollTo', { target: hash, options: { offset: -100 } }, 'Scroll');
            });
        }
    }

    replaceUrl(url) {
        this.load.navigate(url, { history: 'replace', animate: false });
    }

    goTo(url, options = {}) {
        this.load.navigate(url, {
            history: options.history || 'push',
            animate: options.animate !== undefined ? options.animate : true,
            scroll: options.scroll || true
        });
    }

    // ==========================================================================
    // HOOKS
    // ==========================================================================

    onVisitStart(visit) {
        $html.classList.remove('has-dark-hero-inview');
        $html.classList.remove('has-project-anchors-inview');
    }

    onVisitEnd(visit) {
        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.VISIT_END, { detail: visit }));
        this.call('close', null, 'Menu');

        /* Update language */
        const currentLang = document.documentElement.lang;
        const $langSwitcherRef = document.querySelector('[data-lang-switcher-ref]');
        const $allLangSwitcher = document.querySelectorAll('[data-lang-switcher]');
        $allLangSwitcher.forEach(($langSwitcher) => {
            $langSwitcher.href = $langSwitcherRef.href;
        });

        /* Update active menu link */
        const $menuLinks = document.querySelectorAll('[data-menu-link]');
        $menuLinks.forEach(($menuLink) => {
            const $parent = $menuLink.parentElement;
            const urlTarget = visit.to.url;

            if (
                $menuLink.href.includes(urlTarget) &&
                urlTarget !== `/${currentLang}` &&
                !$menuLink.href.includes('#')
            ) {
                $parent.classList.add('is-active');
            } else {
                $parent.classList.remove('is-active');
            }
        });
    }

    onLinkAnchor(visit) {
        this.call('close', null, 'Menu');
    }

    async beforeContentReplace(visit) {}

    onContentReplace(visit) {
        if (visit.to.url !== visit.from.url) {            
            window.scrollTo({
                top: 50,
                left: 0,
                behavior: 'instant'
            });
        }
    }

    onAnimationOutStart(visit) {
        $html.classList.remove(CSS_CLASS.READY);
    }

    onAnimationInStart(visit) {
        $html.classList.add(CSS_CLASS.READY);
    }
}
